/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setActiveTab, clearActiveOa, getActivitiesByTypeAndDate } from '../../actions';
import { maskCep, maskPhone } from '../../utils/helpers';

import Filter from '../Filter/Filter';
import DateFilter from '../Filter/DateFilter';
import Activities from '../Activities/Activities';
import './Infos.css';
import MailIcon from '../../assets/mail-icon.svg';
import PhoneIcon from '../../assets/phone-icon.svg';
import CellPhoneIcon from '../../assets/cellphone-icon.svg';
import { userType } from '../../utils/mockups';

const safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function Infos(props) {
  const { activeOa } = props;
  const handleTabClick = (tab) => {
    props.setActiveTab(tab);
    if (tab === 'atividades') {
      props.getActivitiesByTypeAndDate();
    }
  };
  return (
    <div className="activity-container">
      <div className="tabs col-12 p-0 d-flex justify-content-around">
        <div
          className={`tab col-6 p-0 ${props.activeTab === 'sobre' && 'active'}`}
          onClick={() => handleTabClick('sobre')}
          role="presentation"
        >
          <p>SOBRE</p>
        </div>
        <div
          className={`tab col-6 p-0 ${props.activeTab === 'atividades' && 'active'}`}
          onClick={() => handleTabClick('atividades')}
          role="presentation"
        >
          <p>
            ATIVIDADES NO LOCAL
          </p>
        </div>
      </div>
      <div>
        <h2 className="oa-name">{activeOa.nom_client}</h2>
      </div>
      {activeOa.seq_cadast !== 0 ? (
        <div className={`sobre content ${props.activeTab === 'sobre' && 'active'}`}>
          <div className="info-block">
            <div className="info col-12 col-sm-6">
              <p className="title">Localização</p>
              <div className="contact-info">
                <p>Endereço: </p>
                <span>{`${activeOa.des_lograd}, ${activeOa.num_endere !== null ? activeOa.num_endere : ''}`}</span>
              </div>
              <div className="contact-info">
                <p>Complemento: </p>
                <span>
                  {`${activeOa.des_comple_lograd !== null ? activeOa.des_comple_lograd : ''}`}
                </span>
              </div>
              <div className="contact-info">
                <p>Localidade: </p>
                <span>
                  {`${activeOa.nom_locali}`}
                  {' '}
                  {activeOa.sig_uf && `- ${activeOa.sig_uf}`}
                </span>
              </div>
              <div className="contact-info">
                <p>CEP: </p>
                <span>{`${maskCep(activeOa.cod_cep.trim())}`}</span>
              </div>
            </div>
            <div className="info col-12 col-sm-6 contact-box">
              <p className="title">Contato</p>
              <div className="contact-info ">
                <img className="mr-2" src={PhoneIcon} alt="" />
                <p>Telefone:</p>
                <span>{`${activeOa.num_telefo_fixo !== '' ? maskPhone(activeOa.num_telefo_fixo) : `${activeOa.num_telefo !== '' ? maskPhone(activeOa.num_telefo) : ''}`}`}</span>
              </div>
              <div className="contact-info ">
                <img className="mr-2" src={CellPhoneIcon} alt="" />
                <p>Celular:</p>
                <span>{`${activeOa.num_celula !== '' ? maskPhone(activeOa.num_celula) : `${activeOa.num_celula !== '' ? maskPhone(activeOa.num_celula) : ''}`}`}</span>
              </div>

              <div className="contact-info">
                <img className="mr-2" src={MailIcon} alt="" />
                <p>Email: </p>
                <span>{`${activeOa.des_email !== null ? activeOa.des_email : ''}`}</span>
              </div>
            </div>
            <div className="info col-12 col-sm-12">
              <div className="contact-info">
                <p>Horário Atendimento: </p>
                <span>
                  {`${activeOa.complemento.des_horari_atendi !== null ? activeOa.complemento.des_horari_atendi : ''}`}
                </span>
              </div>
            </div>
          </div>

        </div>
      ) : ''}
      <div className={`atividades content ${props.activeTab === 'atividades' && 'active'} `}>
        {/* <div className={`custom-filters  pt-0 pl-3 ${safari ? 'filter-safari' : ''}`}>
          <Filter
            activity
            history={props.history}
            options={props.activitiesOptions}
            label={props.activityType}
            type="activity"
            searchFilter
          />
          <Filter
            activity
            history={props.history}
            options={userType}
            label={props.publicType}
            type="public"
          />
          <DateFilter
            history={props.history}
            activity

          />
          <Filter
            activity
            history={props.history}
            label={[]}
            type="clear"
          />

        </div> */}
        <Activities />
      </div>

    </div>
  );
}

const mapStateToProps = (store) => ({
  activeOa: store.oasState.activeOa,
  activeTab: store.filterState.activeTab,
  activitiesOptions: store.filterState.activitiesOptions,
  publicType: store.filterState.publicType,
  activityType: store.filterState.activityType,
  activityDate: store.filterState.activityDate,

});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { setActiveTab, clearActiveOa, getActivitiesByTypeAndDate }, dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Infos);
